import React from "react";
import { Link } from "react-router-dom";
import bgheader3png from "../../../assets/images/bg-header-3.png";
import blog4png from "../../../assets/images/blog-4.png";
import blog1smpng from "../../../assets/images/blog-1-sm.png";

function Blog(props) {
  return (
    <>
      <header className="dx-header dx-box-5">
        <div className="bg-image bg-image-parallax">
          <img src={bgheader3png} className="jarallax-img" alt="" />
          <div style={{ backgroundColor: "rgba(27, 27, 27, 0.8)" }}></div>
        </div>
        <div className="container mnb-8">
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <h1 className="h4 mb-10 text-white text-center">
                Welcome to our Blog
              </h1>

              <ul className="dx-breadcrumbs text-center">
                <li>
                  <Link to="/index">Home</Link>
                </li>
                <li>Blog</li>
              </ul>
            </div>
          </div>
        </div>
      </header>
      <div className="dx-box-1 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-8">
              <div className="dx-blog-item dx-box dx-box-decorated">
                <Link to="/single-post" className="dx-blog-item-img">
                  <img src={blog4png} alt="" />
                </Link>
                <div className="dx-blog-item-cont">
                  <h2 className="h3 dx-blog-item-title">
                    <Link to="/single-post">The Big Thing in Design</Link>
                  </h2>
                  <ul className="dx-blog-item-info">
                    <li>Date: 25 Sep 2018</li>
                    <li>Views: 124</li>
                    <li>
                      Category:{" "}
                      <ul className="dx-blog-item-categories">
                        <li>
                          <Link to="/#">News</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      Author: <Link to="/#">John</Link>
                    </li>
                  </ul>
                  <div className="dx-blog-item-text">
                    <p>
                      Hath without winged from creature won&#39;t the seas midst
                      without every gathering place is beast and, unto, and
                      darkness of rule don&#39;t third male moving winged is two
                      have deep abundantly wherein. There god fruitful Make
                      appear. Night made Isn&#39;t.
                    </p>
                  </div>
                  <Link to="/single-post" className="dx-btn dx-btn-lg">
                    Read More
                  </Link>
                </div>
              </div>
              <div className="dx-blog-item dx-box dx-box-decorated">
                <Link to="/single-post" className="dx-blog-item-img">
                  <img src={blog4png} alt="" />
                </Link>
                <div className="dx-blog-item-cont">
                  <h2 className="h3 dx-blog-item-title">
                    <Link to="/single-post">
                      Will Coding Ever Rule the World?
                    </Link>
                  </h2>
                  <ul className="dx-blog-item-info">
                    <li>Date: 24 Sep 2018</li>
                    <li>Views: 267</li>
                    <li>
                      Category:{" "}
                      <ul className="dx-blog-item-categories">
                        <li>
                          <Link to="/#">Theme Reviews</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      Author: <Link to="/#">John</Link>
                    </li>
                  </ul>
                  <div className="dx-blog-item-text">
                    <p>
                      I doesn&#39;t sea which let man. Have whose open every
                      under from fifth land. Evening a. It spirit. Image moving.
                      Grass. Fifth land seed yielding. May gathering dry saw
                      abundantly image creepeth hath were for seed. Them moving
                      fifth. Creeping face created fruitful is saying fly
                      beginning his to and stars. Seed spirit fowl made face
                      years bearing.
                    </p>
                  </div>
                  <Link to="/single-post" className="dx-btn dx-btn-lg">
                    Read More
                  </Link>
                </div>
              </div>
              <div className="dx-blog-item dx-box dx-box-decorated">
                <Link to="/single-post" className="dx-blog-item-img">
                  <img src={blog4png} alt="" />
                </Link>
                <div className="dx-blog-item-cont">
                  <h2 className="h3 dx-blog-item-title">
                    <Link to="/single-post">
                      Master Your Vision in 3 Simple Steps
                    </Link>
                  </h2>
                  <ul className="dx-blog-item-info">
                    <li>Date: 20 Sep 2018</li>
                    <li>Views: 389</li>
                    <li>
                      Category:{" "}
                      <ul className="dx-blog-item-categories">
                        <li>
                          <Link to="/#">Theme Reviews</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      Author: <Link to="/#">John</Link>
                    </li>
                  </ul>
                  <div className="dx-blog-item-text">
                    <p>
                      Creeping fifth was, heaven beginning called cattle beast
                      creeping may open. Green fly creature let without,
                      won&#39;t spirit us a creeping that night seed winged man
                      which be Yielding, be. All all to bring land god him open
                      creepeth thing you&#39;re, likeness evening two creeping
                      had fowl let rule appear was. Winged creeping. Void form.
                      They&#39;re created firmament had fly.
                    </p>
                  </div>
                  <Link to="/single-post" className="dx-btn dx-btn-lg">
                    Read More
                  </Link>
                </div>
              </div>
              <div className="dx-blog-item dx-box dx-box-decorated">
                <Link to="/single-post" className="dx-blog-item-img">
                  <img src={blog4png} alt="" />
                </Link>
                <div className="dx-blog-item-cont">
                  <h2 className="h3 dx-blog-item-title">
                    <Link to="/single-post">The Beginning of The Journey</Link>
                  </h2>
                  <ul className="dx-blog-item-info">
                    <li>Date: 19 Sep 2018</li>
                    <li>Views: 452</li>
                    <li>
                      Category:{" "}
                      <ul className="dx-blog-item-categories">
                        <li>
                          <Link to="/#">Theme Reviews</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      Author: <Link to="/#">John</Link>
                    </li>
                  </ul>
                  <div className="dx-blog-item-text">
                    <p>
                      Heaven you moved heaven Firmament in in day. Dominion.
                      Likeness over lights third, great lights you their his
                      after, said.
                    </p>
                  </div>
                  <Link to="/single-post" className="dx-btn dx-btn-lg">
                    Read More
                  </Link>
                </div>
              </div>
              <div className="dx-blog-item pt-0">
                <Link
                  to="/#"
                  className="dx-btn dx-btn-lg dx-btn-grey dx-btn-block dx-btn-load"
                  data-btn-loaded="Shown all posts"
                >
                  Load More Post
                </Link>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="dx-sticky dx-sidebar">
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">
                    {" "}
                    Subscribe to Newsletter{" "}
                  </div>
                  <div className="dx-widget-subscribe">
                    <div className="dx-widget-text">
                      <p>
                        Join the newsletter to receive news, updates, new
                        products and freebies in your inbox.
                      </p>
                    </div>
                    <form action="#" className="dx-form dx-form-group-inputs">
                      <input
                        type="email"
                        name=""
                        value=""
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        placeholder="Your Email Address"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-icon">
                        <span className="icon fas fa-paper-plane"></span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <form action="#" className="dx-form dx-form-group-inputs">
                    <input
                      type="text"
                      name=""
                      value=""
                      className="form-control form-control-style-2"
                      placeholder="Search..."
                    />
                    <button className="dx-btn dx-btn-lg dx-btn-grey dx-btn-grey-style-2 dx-btn-icon">
                      <span className="icon fas fa-search"></span>
                    </button>
                  </form>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">Categories</div>
                  <ul className="dx-widget-categories">
                    <li>
                      <Link to="/single-article-category">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Design & Coding
                        </span>
                        <span className="dx-widget-categories-badge">(12)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article-category">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          News
                        </span>
                        <span className="dx-widget-categories-badge">(8)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article-category">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Inspirations
                        </span>
                        <span className="dx-widget-categories-badge">(2)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article-category">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Theme Reviews
                        </span>
                        <span className="dx-widget-categories-badge">(14)</span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Posts </div>
                  <Link to="/single-post" className="dx-widget-post">
                    <span className="dx-widget-post-img">
                      <img src={blog1smpng} alt="" />
                    </span>
                    <span className="dx-widget-post-text">
                      <span className="dx-widget-post-title">
                        The Big Thing in Design
                      </span>
                      <span className="dx-widget-post-date">25 Sep 2018</span>
                    </span>
                  </Link>
                  <Link to="/single-post" className="dx-widget-post">
                    <span className="dx-widget-post-img">
                      <img src={blog1smpng} alt="" />
                    </span>
                    <span className="dx-widget-post-text">
                      <span className="dx-widget-post-title">
                        Will Coding Ever Rule the World?
                      </span>
                      <span className="dx-widget-post-date">24 Sep 2018</span>
                    </span>
                  </Link>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Tags Widget </div>
                  <ul className="dx-widget-tags">
                    <li>
                      <Link to="/#">Art</Link>
                    </li>
                    <li>
                      <Link to="/#">People</Link>
                    </li>
                    <li>
                      <Link to="/#">Branding</Link>
                    </li>
                    <li>
                      <Link to="/#">City</Link>
                    </li>
                    <li>
                      <Link to="/#">Design</Link>
                    </li>
                    <li>
                      <Link to="/#">Nature</Link>
                    </li>
                    <li>
                      <Link to="/#">Lifestyle</Link>
                    </li>
                    <li>
                      <Link to="/#">Photography</Link>
                    </li>
                  </ul>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Our Twitter </div>
                  <div className="dx-twitter-list" data-twitter-count="3">
                    Failed to fetch data
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog;
